import {
  LayoutDashboard, ScanLine, Package, QrCode, Bell, PlusCircle, CreditCard,
  Users, ShieldCheck, SlidersHorizontal, ClipboardCheck, ShieldAlert, FileSearch,
  Boxes, TrendingDown, MapPin, ShoppingCart, Receipt, HardHat, Truck, ListChecks, ArrowDownUp, Sparkles, Lightbulb, MonitorDot, ShoppingBasket, Upload, FileText, FileCheck2, Server, PackageSearch, BadgeCheck, FileStack, BookOpenCheck, ClipboardList, Ruler, ClipboardX, Gauge, CircleDot, Activity, CalendarClock, FolderArchive, MonitorSmartphone, KeyRound, MessageSquareWarning, GraduationCap, Target, DoorOpen, PackageCheck, PenLine } from 'lucide-react';
import Ubicaciones from '../paginas/Ubicaciones';
import ListaCompras from '../paginas/ListaCompras';
import PrimeraCosa from '../paginas/PrimeraCosa';
import Casa from '../paginas/Casa';
import { vocabulario } from './vocabulario';
import Dispositivos from '../paginas/Dispositivos';
import Terminales from '../paginas/Terminales';
import Estacion from '../paginas/Estacion';
import Andon from '../paginas/Andon';
import PuntoDeVenta from '../paginas/PuntoDeVenta';
import Ventas from '../paginas/Ventas';
import Activos from '../paginas/Activos';
import Compras from '../paginas/Compras';
import Clientes from '../paginas/Clientes';
import Importar from '../paginas/Importar';
import Facturacion from '../paginas/Facturacion';
import Facturas from '../paginas/Facturas';
import Existencias from '../paginas/Existencias';
import Rastrear from '../paginas/Rastrear';
import Traslados from '../paginas/Traslados';
import Mermas from '../paginas/Mermas';
import Exactitud from '../paginas/Exactitud';
import Anomalias from '../paginas/Anomalias';
import Auditoria from '../paginas/Auditoria';
import Conteos from '../paginas/Conteos';
import Reabastecimiento from '../paginas/Reabastecimiento';
import Tablero from '../paginas/Tablero';
import Productos from '../paginas/Productos';
import Etiquetas from '../paginas/Etiquetas';
import CodigosPorResolver from '../paginas/CodigosPorResolver';
import Presencia from '../paginas/Presencia';
import Aprobaciones from '../paginas/Aprobaciones';
import Autorizaciones from '../paginas/Autorizaciones';
import ConfiguracionControl from '../paginas/ConfiguracionControl';
import AjustesCalidad from '../paginas/AjustesCalidad';
import Documentos from '../paginas/Documentos';
import Inspecciones from '../paginas/Inspecciones';
import NoConformidades from '../paginas/NoConformidades';
import PlanesInspeccion from '../paginas/PlanesInspeccion';
import Instrumentos from '../paginas/Instrumentos';
import Vencimientos from '../paginas/Vencimientos';
import PaqueteEvidencia from '../paginas/PaqueteEvidencia';
import Invitados from '../paginas/Invitados';
import Reclamos from '../paginas/Reclamos';
import Competencias from '../paginas/Competencias';
import MisSesiones from '../paginas/MisSesiones';
import MisLecturas from '../paginas/MisLecturas';
import EsteServidor from '../paginas/EsteServidor';
import MiTrabajo from '../paginas/MiTrabajo';
import Asistente from '../paginas/Asistente';
// R-AO1: el asistente único vive en el carril `asistente`; el caliente solo lo engancha en su sitio de siempre.
import AsistenteUnico from '../asistente/AsistenteOperativo';
import UsuariosPag from '../paginas/Usuarios';
import Escanear from '../mobile/Escanear';
import Alertas from '../mobile/Alertas';
import AltaRapida from '../mobile/AltaRapida';
import Suscripcion from '../mobile/Suscripcion';
import { gruposDeCarriles, fundirGrupos } from '../carriles/index.js';

// Registro de módulos de la consola. `min` es el rol mínimo (se valida
// también en el backend; ocultar el módulo es comodidad, no seguridad).
const GRUPOS_BASE = [
  {
    grupo: 'Operación',
    items: [
      // Lo primero de la lista y lo primero que se ve al entrar: es la
      // respuesta a «¿qué hago ahora?», que hasta ahora no daba nadie.
      { id: 'mi-trabajo', etiqueta: 'Mi trabajo', icono: ListChecks, min: 'CONSULTA', soloEmpresa: true, Comp: MiTrabajo },
      // EL INICIO DE UNA CASA NO ES EL DE UN ALMACEN. «Mi trabajo» reparte
      // tareas entre personas y el Tablero cuenta como va el NEGOCIO —valor
      // del inventario, rotacion, margenes—. Quien inventaria su casa tiene
      // otras dos preguntas y solo dos: que me falta, y que tengo.
      { id: 'casa', etiqueta: 'Mi casa', icono: ListChecks, min: 'CONSULTA', soloPersonal: true, Comp: Casa },
      // Responde lo que el rol puede ver, asi que lo abre cualquiera.
      // R-AO1 (decisión del dueño, 17 sep 2026): UN solo asistente, el del
      // carril `asistente` (mismo id `asistente`, en Operación). Esta
      // pantalla queda APAGADA, NO BORRADA —como `LandingPage`—: sigue en
      // el árbol y su ruta /api/bot/preguntar sigue viva. `oculto` la saca
      // del menú sin quitarle el archivo a nadie.
      { id: 'asistente', etiqueta: 'Asistente', icono: Sparkles, min: 'CONSULTA', Comp: AsistenteUnico },
      { id: 'asistente-clasico', etiqueta: 'Asistente (clásico, apagado)', icono: Sparkles, min: 'DUENO', oculto: true, Comp: Asistente },
      { id: 'tablero', etiqueta: 'Tablero', icono: LayoutDashboard, min: 'CONSULTA', soloEmpresa: true, Comp: Tablero },
      // EL ANDÓN NO ES EL TABLERO. El Tablero cuenta cómo va el NEGOCIO
      // —valor del inventario, ventas, márgenes— y se mira sentado. El
      // andón dice si hay que ir a algún sitio AHORA, se lee desde diez
      // metros y se cuelga de una pared. Lo abre cualquiera que pueda
      // consultar: la gracia es que lo vea quien pasa por el pasillo,
      // que es quien puede ir a resolverlo.
      { id: 'andon', etiqueta: 'Cómo va el almacén', icono: MonitorDot, min: 'CONSULTA', soloEmpresa: true, Comp: Andon },
      // JUNTO AL ANDÓN Y NO DENTRO. El andón mira el ALMACÉN entero y se
      // cuelga de una pared; esto mira UNA estación y se abre para
      // preguntar por ella: «¿qué está pasando ahora en Línea 2?». Es la
      // pantalla que se enseña en una demo, y por eso lleva la misma
      // regla que la terminal: ni un peso.
      { id: 'estacion', etiqueta: 'Cómo va una estación', icono: Activity, min: 'CONSULTA', soloEmpresa: true, Comp: Estacion },
      // El mostrador va arriba y antes que el catálogo: en una tienda es la
      // pantalla en la que se pasa el día, no una más de la lista.
      { id: 'pos', etiqueta: 'Punto de venta', icono: ShoppingCart, min: 'OPERADOR', soloEmpresa: true, Comp: PuntoDeVenta },
      { id: 'ventas', etiqueta: 'Ventas', icono: Receipt, min: 'OPERADOR', soloEmpresa: true, Comp: Ventas },
      // PRIMER MODULO QUE SE ENSEÑA POR PERMISO Y NO POR RANGO. `clientes`
      // se puede conceder a una persona concreta sin subirla de puesto, y
      // filtrarlo por rol habria abierto la puerta por la API y ninguna
      // por la pantalla. `min` se queda como respaldo para un token viejo
      // que todavia no traiga la lista de permisos.
      // Junto a Ventas porque se factura lo que se vendio, y porque la
      // pantalla existe sobre todo para resolver las facturas sin
      // confirmar: eso tiene que estar donde alguien pase todos los dias.
      { id: 'facturas', etiqueta: 'Facturas', icono: FileCheck2, permiso: 'facturar', min: 'ENCARGADO', soloEmpresa: true, Comp: Facturas },
      { id: 'clientes', etiqueta: 'Clientes', icono: Users, permiso: 'clientes', min: 'ENCARGADO', soloEmpresa: true, Comp: Clientes },
      { id: 'escanear', etiqueta: 'Escanear', icono: ScanLine, min: 'CONSULTA', Comp: Escanear },
      { id: 'productos', etiqueta: 'Productos', icono: Package, min: 'CONSULTA', Comp: Productos },
      { id: 'existencias', etiqueta: 'Existencias', icono: Boxes, min: 'CONSULTA', Comp: Existencias },
      // JUNTO A EXISTENCIAS, y no dentro de Inventario: la pregunta que
      // contesta —«¿dónde está lo que mandé el martes?»— es de las de
      // mirar, no de las de capturar. Lo abre quien mueve mercancía; el
      // permiso `mover` lo comprueba el backend en cada una de las tres
      // acciones.
      { id: 'traslados', etiqueta: 'Traslados', icono: Truck, min: 'OPERADOR', soloEmpresa: true, Comp: Traslados },
      { id: 'etiquetas', etiqueta: 'Etiquetas QR', icono: QrCode, min: 'CONSULTA', Comp: Etiquetas },
      // ACCESOS FASE 4. Lo que se escaneó y TEGO no supo qué era. Va con
      // el permiso de catálogo y no con un rol: resolver un código es
      // decidir de qué producto es, que es exactamente lo que ese
      // permiso significa.
      { id: 'codigos-por-resolver', etiqueta: 'Códigos que TEGO no reconoció', icono: ScanLine, permiso: 'catalogo', min: 'ENCARGADO', soloEmpresa: true, Comp: CodigosPorResolver },
      // ACCESOS FASE 5. Quién está dentro y la asistencia. VA POR PERMISO
      // y no por rango: quién puede mirar a qué hora entra la gente no es
      // una cuestión de nivel — un encargado de turno lo necesita y un
      // administrador de sistemas puede no tener por qué. Son datos
      // personales de la plantilla.
      // ANEXO-CLIENTE-01 H-3 (20 sep 2026): «Presencia» necesitaba el cuadro
      // azul para entenderse. El título dice qué es; el subtítulo de la
      // pantalla dice para qué sirve. El `id` no cambia (los enlaces siguen).
      { id: 'presencia', etiqueta: 'Entradas y salidas', icono: DoorOpen, permiso: 'presencia.ver', min: 'ENCARGADO', soloEmpresa: true, Comp: Presencia },
      { id: 'alertas', etiqueta: 'Alertas', icono: Bell, min: 'CONSULTA', Comp: Alertas },
      // SOLO CUENTAS PERSONALES, y es simétrico a `soloEmpresa`. En una
      // cuenta personal, lo que baja de su mínimo se apunta AQUÍ; en una
      // empresa va al centro de notificaciones y de ahí al flujo de
      // compras, que es otro módulo y otra conversación (con proveedor,
      // orden y recepción). Enseñar las dos a la vez haría que nadie
      // supiera en cuál mirar.
      { id: 'lista-compras', etiqueta: 'Lista de compras', icono: ShoppingBasket, min: 'CONSULTA', soloPersonal: true, Comp: ListaCompras },
      // Un operador ve la bandeja para saber si ya le autorizaron lo suyo;
      // resolver es otra cosa, y eso lo valida el backend.
      // ANEXO-CLIENTE-01 H-5 (20 sep 2026): «Aprobaciones» y «Autorizaciones»
      // con el mismo escudo obligaban a entrar a las dos para saber cuál era
      // cuál. Se quedan separadas —son dos cosas— y cada una se llama por lo
      // que pasa ahí, con icono distinto. Los `id` no cambian.
      { id: 'aprobaciones', etiqueta: 'Salidas por aprobar', icono: PackageCheck, min: 'OPERADOR', soloEmpresa: true, Comp: Aprobaciones },
      // ACCESOS FASE 3. AL LADO de «Aprobaciones», no en su lugar: aquella
      // es el cuatro ojos de los movimientos (migración 013) y sigue
      // mandando sobre lo suyo. Aquí caen las demás acciones —ajustes,
      // bajas de producto, cambios de puesto— y solo si la empresa las
      // tiene encendidas; de fábrica están todas apagadas.
      //
      // Mismo mínimo que su hermana, y por lo mismo: un operador entra a
      // ver si ya le autorizaron lo suyo. Quién puede FIRMAR lo dice el
      // permiso de cada regla, y eso lo valida el backend.
      { id: 'autorizaciones', etiqueta: 'Firmas pendientes', icono: PenLine, min: 'OPERADOR', soloEmpresa: true, Comp: Autorizaciones },
      // El operador cuenta; abrir y cerrar la sesion exige encargado, y eso
      // lo valida el backend.
      { id: 'conteos', etiqueta: 'Conteos', icono: ClipboardCheck, min: 'OPERADOR', soloEmpresa: true, Comp: Conteos },
      // El operador repone; decidir cuanto debe haber en cada hueco exige
      // encargado, y eso lo valida el backend.
      { id: 'reabastecimiento', etiqueta: 'Reabastecimiento', icono: ArrowDownUp, min: 'OPERADOR', soloEmpresa: true, Comp: Reabastecimiento },
      { id: 'alta', etiqueta: 'Alta rápida', icono: PlusCircle, min: 'ENCARGADO', soloEmpresa: true, Comp: AltaRapida },
      // EL ALTA DE UNA CASA ES OTRA COSA. «Alta rápida» pide SKU, unidad de
      // medida y ubicación: es la de un almacén, y en una casa es un muro.
      // Esta pregunta qué clase de cosa es, cómo se llama, y ya.
      { id: 'registrar', etiqueta: 'Registrar algo', icono: PlusCircle, min: 'CONSULTA', soloPersonal: true, Comp: PrimeraCosa },
      // Activos y Compras existian solo en la API desde su fase: se podia
      // registrar una laptop o recibir una orden con `curl` y desde
      // ninguna pantalla.
      { id: 'activos', etiqueta: 'Activos', icono: HardHat, min: 'CONSULTA', Comp: Activos },
      { id: 'compras', etiqueta: 'Compras', icono: Truck, min: 'ENCARGADO', soloEmpresa: true, Comp: Compras },
      // «DINERO EN LA MESA» SE FUE DE AQUI el 4 de septiembre de 2026, al
      // enganche: `frontend/src/carriles/ventaja.modulos.jsx`. Su `id` es
      // ahora `ventaja-dinero-en-la-mesa` y vive en el grupo «Compras y
      // proveedores». El porqué del prefijo y del grupo está escrito allí.
    ],
  },
  // =====================================================================
  // CALIDAD · un grupo propio, y no una fila más en «Operación»
  // =====================================================================
  // «Operación» ya tiene veintitrés entradas. Meter ahí las pantallas de
  // calidad haría que nadie encontrara nada, y eso choca de frente con la
  // Doctrina 2: una pantalla que no se encuentra es una pantalla que no
  // existe. Además son de otra persona y de otro momento del día — quien
  // rastrea un lote no está surtiendo pedidos.
  //
  // SOLO EMPRESA. En una casa no hay proveedores con certificado de
  // material ni auditores que pidan una cadena de custodia.
  {
    grupo: 'Calidad',
    items: [
      // Se enseña POR PERMISO y no por rango, como `clientes` y
      // `facturas`: `trazabilidad.ver` se le puede conceder a un
      // inspector concreto sin subirlo de puesto, y filtrarlo por rol
      // habría abierto la puerta por la API y ninguna por la pantalla.
      // `min` se queda como respaldo para un token viejo que todavía no
      // traiga la lista de permisos.
      // CONTROL DE DOCUMENTOS · Fase 2 del módulo de Calidad.
      //
      // DOS ENTRADAS Y NO UNA, y es la decisión que decide si esto se
      // usa. «Documentos» lo abre calidad de vez en cuando; «Tengo que
      // leer» lo abre un operador y tiene que encontrar SOLO lo suyo. Una
      // sola pantalla obligaría a quien viene a acusar una lectura a
      // buscarse entre todos los procedimientos de la planta.
      { id: 'documentos', etiqueta: 'Documentos', icono: FileStack, permiso: 'documentos.ver', min: 'CONSULTA', soloEmpresa: true, Comp: Documentos },
      { id: 'mis-lecturas', etiqueta: 'Tengo que leer', icono: BookOpenCheck, permiso: 'documentos.ver', min: 'CONSULTA', soloEmpresa: true, Comp: MisLecturas },
      { id: 'rastrear', etiqueta: 'Rastrear un lote', icono: PackageSearch, permiso: 'trazabilidad.ver', min: 'OPERADOR', soloEmpresa: true, Comp: Rastrear },
      // INSPECCIONES · Fase 3 del módulo de Calidad.
      //
      // DOS ENTRADAS Y NO UNA, por lo mismo que en documentos. Las abre
      // gente distinta: «Inspecciones» la abre quien mide, todos los
      // días, y trae arriba lo que está retenido esperando decisión.
      // «Qué se revisa de cada producto» la abre ingeniería de calidad
      // de tarde en tarde para decidir las cotas, y por eso va detrás y
      // con su propio permiso: quien mide no decide qué se mide.
      //
      // EL NOMBRE DE LA SEGUNDA NO ES «PLANES DE INSPECCIÓN». Así lo
      // llama la norma; «qué se revisa de cada producto» es como lo
      // pregunta quien entra por primera vez, que es de quien va esta
      // doctrina.
      { id: 'inspecciones', etiqueta: 'Inspecciones', icono: ClipboardList, permiso: 'calidad.ver', min: 'CONSULTA', soloEmpresa: true, Comp: Inspecciones },
      { id: 'planes-inspeccion', etiqueta: 'Qué se revisa de cada producto', icono: Ruler, permiso: 'calidad.plan_editar', min: 'ENCARGADO', soloEmpresa: true, Comp: PlanesInspeccion },
      // NO CONFORMIDADES · Fase 4 del módulo de Calidad.
      //
      // SE ENSEÑA CON `calidad.ver` Y NO CON EL DE ABRIR, y es a
      // propósito: quien inspecciona tiene que poder VER la no
      // conformidad que su propia inspección acaba de abrir, aunque no
      // pueda resolverla. Los dos permisos propios de la fase gobiernan
      // los botones de dentro, no la puerta.
      //
      // «Lo que me toca a mí» vive DENTRO de esta pantalla y no como
      // entrada aparte: es lo primero que se ve al abrirla, y una
      // undécima entrada en la barra por algo que se lee en dos
      // segundos haría más difícil encontrar todo lo demás.
      { id: 'no-conformidades', etiqueta: 'No conformidades', icono: ClipboardX, permiso: 'calidad.ver', min: 'CONSULTA', soloEmpresa: true, Comp: NoConformidades },
      { id: 'reclamos', etiqueta: 'Reclamos de cliente', icono: MessageSquareWarning, permiso: 'calidad.ver', min: 'CONSULTA', soloEmpresa: true, Comp: Reclamos },
      // INSTRUMENTOS · Fase 5 del módulo de Calidad.
      //
      // DOS ENTRADAS Y NO UNA, por tercera vez en este grupo y por el
      // mismo motivo. «Instrumentos de medición» es el catálogo: se
      // abre para dar de alta un vernier o para buscar su certificado.
      // «Qué hay que calibrar» es la pregunta del lunes por la mañana —
      // «¿qué se me está pasando?»— y tiene que contestarse sin filtrar
      // nada. Una sola pantalla habría dejado la urgente escondida
      // detrás de la del catálogo.
      //
      // LAS DOS CON `calidad.instrumentos` Y NO CON `calidad.ver`, que
      // es la diferencia con inspecciones y no conformidades. Aquellas
      // las tiene que VER quien mide, aunque no pueda tocarlas — su
      // inspección abre la no conformidad. Éstas son de metrología: no
      // hay nada dentro que quien mide necesite mirar y no vea ya en el
      // selector de la pantalla de captura, que sí trae la vigencia de
      // cada instrumento al lado.
      { id: 'instrumentos', etiqueta: 'Instrumentos de medición', icono: Gauge, permiso: 'calidad.instrumentos', min: 'ENCARGADO', soloEmpresa: true, Comp: Instrumentos },
      { id: 'vencimientos', etiqueta: 'Qué hay que calibrar', icono: CalendarClock, permiso: 'calidad.instrumentos', min: 'ENCARGADO', soloEmpresa: true, Comp: Vencimientos },
      // PAQUETE DE EVIDENCIA · Fase 6, y con ella cierra el módulo.
      //
      // ÚLTIMA DEL GRUPO A PROPÓSITO, y no es orden alfabético: es la
      // única que se abre el día de la auditoría y no en el día a día.
      // Arriba va lo que alguien toca todas las mañanas.
      //
      // SE ENSEÑA CON `calidad.ver` Y NO CON EL DE ARMARLO, al revés que
      // instrumentos. Quien inspecciona tiene que poder comprobar que lo
      // suyo entró en el paquete de enero, y bajarlo si se lo piden. El
      // permiso de armar gobierna el formulario de dentro, no la puerta:
      // armarlo es ENTREGAR fuera todo lo de calidad de un trimestre.
      { id: 'paquete-evidencia', etiqueta: 'Carpeta para la auditoría', icono: FolderArchive, permiso: 'calidad.ver', min: 'CONSULTA', soloEmpresa: true, Comp: PaqueteEvidencia },
      { id: 'invitados', etiqueta: 'Accesos de auditor', icono: KeyRound, permiso: 'calidad.invitado', min: 'ADMIN', soloEmpresa: true, Comp: Invitados },
    ],
  },
  {
    grupo: 'Vigilancia',
    items: [
      { id: 'anomalias', etiqueta: 'Movimientos raros', icono: ShieldAlert, min: 'ENCARGADO', soloEmpresa: true, Comp: Anomalias },
      { id: 'auditoria', etiqueta: 'Auditoría', icono: FileSearch, min: 'ENCARGADO', Comp: Auditoria },
      { id: 'mermas', etiqueta: 'Mermas', icono: TrendingDown, min: 'ENCARGADO', Comp: Mermas },
      // TC-32. Va junto a Mermas y no dentro de Conteos: las dos salen de
      // los mismos conteos, pero contestan preguntas distintas. Mermas
      // dice CUÁNTO se perdió; ésta, si el inventario es de fiar — y esa
      // segunda es la que se lleva a una auditoría de cliente.
      { id: 'exactitud', etiqueta: 'Exactitud de inventario', icono: Target, min: 'ENCARGADO', Comp: Exactitud },
    ],
  },
  {
    grupo: 'Administración',
    items: [
      // Es el PRIMER paso de la puesta en marcha: sin ubicaciones no se
      // puede registrar una sola entrada.
      { id: 'almacen', etiqueta: 'Almacén', icono: MapPin, min: 'ENCARGADO', Comp: Ubicaciones },
      // Va junto a Almacén porque es lo mismo visto de otra forma: dónde
      // está cada cosa. Lo abre un encargado —montar una tira es organizar
      // el almacén—, y la contraseña de conexión solo un administrador.
      { id: 'dispositivos', etiqueta: 'Dispositivos', icono: Lightbulb, min: 'ENCARGADO', soloEmpresa: true, Comp: Dispositivos },
      // JUNTO A «Dispositivos» Y NO DENTRO. Se parecen en el nombre y en
      // nada más: «Dispositivos» son las tiras de luz de las repisas —se
      // encienden y se apagan—, y una terminal de conteo tiene personas
      // delante y mueve inventario a nombre de alguien. Juntarlas
      // obligaría a explicar en cada botón a cuál de las dos se refiere.
      { id: 'terminales', etiqueta: 'Terminales de conteo', icono: CircleDot, min: 'ENCARGADO', soloEmpresa: true, Comp: Terminales },
      { id: 'control', etiqueta: 'Visto bueno', icono: SlidersHorizontal, min: 'ADMIN', soloEmpresa: true, Comp: ConfiguracionControl },
      // JUNTO A «Control de movimientos» y no dentro. Son dos decisiones
      // distintas que toma la misma persona, pero mezclarlas haría que
      // quien busca «¿por qué me pide el lote del proveedor?» tuviera que
      // leer una pantalla de umbrales de autorización para encontrarlo.
      //
      // POR PERMISO, no por rango: `calidad.configurar` se le puede
      // conceder al responsable de calidad de una planta sin darle además
      // la gestión de usuarios y de sucursales.
      { id: 'calidad-ajustes', etiqueta: 'Ajustes de calidad', icono: BadgeCheck, permiso: 'calidad.configurar', min: 'ADMIN', soloEmpresa: true, Comp: AjustesCalidad },
      // «PARAMETROS COMERCIALES» SE FUE DE AQUI el 4 de septiembre de 2026,
      // al enganche: `frontend/src/carriles/ventaja.modulos.jsx`. Su `id`
      // es ahora `ventaja-parametros`.
      // CÓMO ESTÁ LA MÁQUINA, para su dueño y sin llamar a nadie. Lo que
      // se ve aquí —si el respaldo corrió, cuánto disco queda, qué
      // versión corre— lo sabía TEGO desde hace bloques y solo lo veía el
      // panel del proveedor. Es el §7 de la directriz de nodos: «nunca un
      // icono verde que miente».
      { id: 'servidor', etiqueta: 'Este servidor', icono: Server, min: 'ADMIN', Comp: EsteServidor },
      // Solo cuentas de EMPRESA: una cuenta personal es de un solo usuario.
      { id: 'usuarios', etiqueta: 'Personal', icono: Users, min: 'ADMIN', soloEmpresa: true, Comp: UsuariosPag },
      { id: 'competencias', etiqueta: 'Quién puede hacer qué', icono: GraduationCap, permiso: 'personal.competencias_ver', min: 'ENCARGADO', soloEmpresa: true, Comp: Competencias },
      // Nadie llega a TEGO desde cero: llega desde otro sistema o desde
      // un Excel. Va en Administración y no en Operación porque una
      // carga masiva es la operación con más alcance por clic que hay.
      { id: 'importar', etiqueta: 'Traer mis datos', icono: Upload, permiso: 'importar', min: 'ADMIN', soloEmpresa: true, Comp: Importar },
      // Preparar la facturación va aquí y no en Operación porque es
      // trabajo de puesta en marcha: se hace una vez, con el contador
      // al lado, y luego no se vuelve a abrir.
      { id: 'facturacion', etiqueta: 'Preparar la facturación', icono: FileText, min: 'ADMIN', soloEmpresa: true, Comp: Facturacion },
      { id: 'suscripcion', etiqueta: 'Suscripción', icono: CreditCard, min: 'ADMIN', Comp: Suscripcion },
      // TUS SESIONES ABIERTAS · deuda T-c.
      //
      // LA ABRE CUALQUIERA, y no es un descuido: es sobre uno mismo.
      // Cada persona ve SOLO las suyas —el endpoint filtra por el
      // usuario del token, no por un parámetro— así que pedir un rango
      // para poder cerrar tu propia sesión sería un trámite entre una
      // persona y su propia llave.
      //
      // EN ADMINISTRACIÓN Y NO EN OPERACIÓN porque no se abre todos los
      // días: se abre el día que algo no cuadra.
      { id: 'mis-sesiones', etiqueta: 'Tus sesiones abiertas', icono: MonitorSmartphone, min: 'CONSULTA', Comp: MisSesiones },
    ],
  },
];

/* =====================================================================
   Y LO QUE TRAIGAN LOS CARRILES · directriz de carriles, Fase 3
   =====================================================================
   Todo lo de arriba se queda exactamente como estaba. Un carril nuevo no
   escribe aquí: deja `frontend/src/carriles/<carril>.modulos.jsx` con
   sus grupos y aparecen solos, ordenados por su `orden`.

   POR QUE. Este archivo es EL caliente del cliente —388 líneas, 55
   `import`, cincuenta entradas— y todo el que añade una pantalla tiene
   que escribir su línea en el mismo sitio. Eso no es un descuido de
   nadie: es un conflicto garantizado en cuanto hay dos sesiones. Un
   caliente se engancha, no se edita.
   ===================================================================== */
/* `fundirGrupos` junta los grupos que se llaman igual · INT-3, autorizado
   el 9 de septiembre de 2026. Sin él, un carril que declare «Operación»
   pinta una segunda cabecera «Operación» debajo de la primera y quien
   busca una pantalla la busca arriba y no está. El orden es el de la
   primera aparición: un grupo que ya existe no se mueve porque alguien le
   añada algo. */
export const GRUPOS = fundirGrupos([...GRUPOS_BASE, ...gruposDeCarriles()]);

// Qué módulos ve alguien, por su rol y por su tipo de cuenta.
//
// VIVE AQUÍ Y NO DENTRO DE LA CONSOLA para que se pueda probar la regla
// de verdad. Escrita dentro de `AppShell`, la única forma de probarla
// sería copiarla en la prueba — y una prueba que compara el código con una
// copia suya pasa aunque el código cambie. Ya pasó una vez en este
// repositorio y no volvió a pasar por escribirlo así.
//
// NO ES UN PERMISO. El backend valida cada petición; esto solo evita
// enseñar puertas que no llevan a ningún sitio.
// Los modulos cuyo NOMBRE cambia con el tipo de cuenta. En una casa no hay
// «activos»: hay pertenencias. Ver `vocabulario.js` para por que esto no
// contradice la regla de consistencia de la Doctrina 2.
const RENOMBRA = {
  productos: 'productos', activos: 'activos', almacen: 'almacen',
  existencias: 'existencias', 'mi-trabajo': 'miTrabajo', tablero: 'tablero',
};

// `puede` es opcional para no romper a ningun llamador viejo: sin ella,
// un modulo con `permiso` se comporta como antes y cae en su `min`.
export function modulosVisibles(tieneNivel, esEmpresa, puede = null) {
  const palabras = vocabulario(esEmpresa);
  // UN MODULO SE ENSEÑA POR CAPACIDAD SI LA DECLARA, y por rango si no.
  // Con `permiso`, quien lo tenga concedido a titulo individual ve su
  // modulo aunque su puesto no llegue: sin esto, conceder un permiso
  // abriria la puerta por la API y ninguna por la pantalla.
  const visible = (m) => {
    if (m.oculto) return false;              // apagada a propósito (R-AO1)
    if (m.permiso && puede) return puede(m.permiso);
    return tieneNivel(m.min);
  };
  return GRUPOS
    .map((g) => ({
      ...g,
      items: g.items
        .filter((m) => visible(m)
          && (!m.soloEmpresa || esEmpresa)
          && (!m.soloPersonal || !esEmpresa))
        .map((m) => (RENOMBRA[m.id]
          ? { ...m, etiqueta: palabras[RENOMBRA[m.id]] }
          : m)),
    }))
    .filter((g) => g.items.length > 0);
}

// Dónde aterriza cada rol al entrar.
//
// TODOS caen en «Mi trabajo». El operador aterrizaba en Escanear —útil,
// pero es una herramienta, no una respuesta: dice CÓMO registrar algo y no
// QUÉ hay que hacer—. Y quien manda aterrizaba en el Tablero, que cuenta
// cómo va el negocio y tampoco reparte trabajo. Escanear queda a un toque
// desde aquí, que es lo que hace que este cambio no estorbe a quien solo
// venía a escanear.
export function moduloInicial(esEmpresa = true) {
  // Cada tipo de cuenta aterriza en SU respuesta a «¿y ahora qué?». Para
  // una empresa es el reparto de trabajo; para una casa, qué falta y qué
  // hay. Aterrizar a una persona en «Mi trabajo» seria darle la pantalla
  // de un almacen el primer segundo.
  return esEmpresa ? 'mi-trabajo' : 'casa';
}
